import { render, staticRenderFns } from "./ProductReviewsSummary.vue?vue&type=template&id=48f624fc&scoped=true&"
import script from "./ProductReviewsSummary.vue?vue&type=script&lang=js&"
export * from "./ProductReviewsSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProductReviewsSummary.vue?vue&type=style&index=0&id=48f624fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f624fc",
  null
  
)

export default component.exports